import { Alert, Button, Card, CardBody, Input } from '@foundation/ui'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { AppLayout } from '@/components/AppLayout'
import { api } from '@/lib/api'
import { isAuthenticated } from '@/lib/auth-store'
import { toast } from '@/lib/toast'

export const Route = createFileRoute('/settings-team')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' })
    }
  },
  component: TeamSettingsPage,
})

function TeamSettingsPage() {
  const [team, setTeam] = useState<unknown[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [inviteEmail, setInviteEmail] = useState('')
  const [isInviting, setIsInviting] = useState(false)

  useEffect(() => {
    api
      .getTeam()
      .then((res) => setTeam(res.data))
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : 'Failed to load team')
      })
      .finally(() => setIsLoading(false))
  }, [])

  const handleInvite = (e: React.FormEvent): void => {
    e.preventDefault()
    if (!inviteEmail) return
    setIsInviting(true)
    api
      .inviteTeamMember({ email: inviteEmail, role: 'member' })
      .then(() => {
        toast.success(`Invitation sent to ${inviteEmail}`)
        setInviteEmail('')
      })
      .catch((err: unknown) => {
        toast.error(err instanceof Error ? err.message : 'Failed to send invitation')
      })
      .finally(() => setIsInviting(false))
  }

  return (
    <AppLayout title="Team Management">
      <Card style={{ marginBottom: '1.5rem' }}>
        <CardBody>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginBottom: '0.5rem' }}>
            Team Members
          </h2>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem' }}>
            Manage your team. Available on Business plan only.
          </p>

          {error && (
            <Alert variant="danger" style={{ marginBottom: '1rem' }}>
              {error}
            </Alert>
          )}

          {!isLoading && team.length === 0 && (
            <p style={{ color: 'var(--text-muted)', marginBottom: '1.5rem' }}>
              No team members yet. Invite your first team member below.
            </p>
          )}

          <form
            onSubmit={handleInvite}
            style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-end' }}
          >
            <div style={{ flex: 1 }}>
              <Input
                label="Email Address"
                type="email"
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
                placeholder="colleague@company.com"
                required
              />
            </div>
            <Button type="submit" variant="primary" loading={isInviting}>
              Invite
            </Button>
          </form>
        </CardBody>
      </Card>
    </AppLayout>
  )
}
